// true if string is a number between 1 - 365
export const isValidDayOfYear = (input: string): boolean => {
  const inputAsNumber = parseInt(input, 10);
  if (inputAsNumber) {
    return inputAsNumber > 0 && inputAsNumber <= 365;
  }
  return false;
};

export const isValidUriElement = (str: string): boolean => {
  return !/[^\w\s-]/gi.exec(str);
};

export const isValidUrl = (str: string): boolean => {
  const pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
    'i'
  );
  return !!pattern.test(str);
};
